import React from 'react';

import DatePicker from "react-datepicker"

import { registerLocale, setDefaultLocale, setHours, setMinutes } from  "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import fi from 'date-fns/locale/fi';
registerLocale('fi', fi)

class StartDate extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { startDate, editDate } = this.props

    if (!startDate) {
      return (null)
    }

    return(
      <div className={"card-item" + (editDate ? "" : " disabled")}>
        <p>Voimassaolon alku</p>
        <div className="card-input">
          <DatePicker
            todayButton={"Tänään"}
            disabled={!this.props.editDate}
            selected={Date.parse(this.props.startDate)}
            locale="fi"
            onChange={this.props.editDate}
            showTimeSelect
            dateFormat="dd.MM.yyyy hh:mm"
          />
        </div>
      </div>
    )
  }
};

export default StartDate
